/**
 * Adds SGR packaging-deposit line items alongside beverage products.
 * Products with custom.sgr get a matching deposit variant from theme settings.
 */
(function () {
  'use strict';

  function parseQuantity(form, fallback) {
    var input = form && form.querySelector('[name="quantity"]');
    var qty = input ? parseInt(input.value, 10) : fallback || 1;
    if (isNaN(qty) || qty < 1) return fallback || 1;
    return qty;
  }

  function isValidVariantId(id) {
    if (!id) return false;
    var s = String(id).trim();
    return /^\d{10,}$/.test(s);
  }

  function withSections(payload, cart) {
    if (!cart || typeof cart.getSectionsToRender !== 'function') return payload;
    payload.sections = cart
      .getSectionsToRender()
      .map(function (section) {
        return section.id;
      })
      .join(',');
    payload.sections_url = window.location.pathname;
    return payload;
  }

  function cartAdd(payload) {
    return fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(payload),
    }).then(function (res) {
      return res.json();
    });
  }

  window.NrSgrCart = {
    addItems: function (variantId, quantity, sgrVariantId, cart, activeElement) {
      if (cart && typeof cart.setActiveElement === 'function' && activeElement) {
        cart.setActiveElement(activeElement);
      }

      var mainPayload = withSections(
        {
          items: [{ id: String(variantId), quantity: quantity }],
        },
        cart
      );

      return cartAdd(mainPayload).then(function (mainResponse) {
        if (mainResponse.status || !isValidVariantId(sgrVariantId)) {
          return mainResponse;
        }

        var sgrPayload = withSections(
          {
            items: [{ id: String(sgrVariantId), quantity: quantity }],
          },
          cart
        );

        return cartAdd(sgrPayload).then(function (sgrResponse) {
          if (!sgrResponse.status) return sgrResponse;
          console.warn(
            'SGR deposit could not be added:',
            sgrResponse.description || sgrResponse.message
          );
          return mainResponse;
        });
      });
    },

    addFromForm: function (form, cart, activeElement) {
      var variantInput = form.querySelector('[name="id"]');
      var variantId = variantInput && variantInput.value;
      var quantity = parseQuantity(form, 1);
      var productForm = form.closest('product-form');
      var sgrVariantId =
        productForm && productForm.getAttribute('data-sgr-deposit-variant-id');
      if (!isValidVariantId(sgrVariantId)) sgrVariantId = null;
      return this.addItems(variantId, quantity, sgrVariantId, cart, activeElement);
    },
  };
})();
